// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutSharedStyles } from "@sc/App/SharedStyles/CheckoutSharedStyles";
import { billingAndShippingStyles } from "@sc/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationBillingAndShipping";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

billingAndShippingStyles.title = {
    ...checkoutSharedStyles.sectionTitle,
};

billingAndShippingStyles.container = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 22px;
        row-gap: 24px;
    `,
};
billingAndShippingStyles.billToGridItem = {
    css: css`
        width: calc((100% - 44px) / 3);
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
billingAndShippingStyles.shipToGridItem = {
    css: css`
        width: calc((100% - 44px) / 3);
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
billingAndShippingStyles.pickUpGridItem = {
    css: css`
        width: calc((100% - 44px) / 3);
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
billingAndShippingStyles.notesTitle = {
    ...checkoutSharedStyles.subSectionTitle,
};
billingAndShippingStyles.notesDescription = {
    forwardAs: "p",
    size: 14,
    lineHeight: "22px",
    css: css`
        overflow-wrap: break-word;
    `,
};
billingAndShippingStyles.notesWrapper = {
    css: css`
        width: 100%;
    `,
};
billingAndShippingStyles.addressTextStyle = {
    css: css`
        margin-bottom: 0;
    `,
};
